import './globals.css'
import { createClientApp } from '../../shared/ssr/entry-client'
import { createApp } from './main'

createClientApp(createApp)
